import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { setUser } from "../../../../store/action/auth";
import HttpService from "../../../../services/http_service/HttpService";
import Http from "../../../../services/http/Http";
import Empty from "../empty";
import Item from "./Item";
import Loading from "./loading";
import { Div } from "../style";
import { useHistory } from "react-router";
import Notification from "../../../../services/notification/Notification";

const Ongoing = (props) => {
  let history = useHistory();

  const { user } = props;

  const [isLoadingGetData, setIsLoadingGetData] = useState(false);
  const [orders, setOrders] = useState([]);

  const getOrders = useCallback(() => {
    setIsLoadingGetData(true);

    HttpService(user?.token)
      .get("user/orders?status=0,1,2,3")
      .then((response) => {
        setOrders(response.data.entity);
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .then(() => {
        setIsLoadingGetData(false);
      });
  }, [props, user]);

  useEffect(() => {
    getOrders();

    if (history?.location?.search?.split("?")[1]) {
      var data = history?.location?.search?.split("?")[1].split("=");
      if (data[0] === "status") {
        if (data[1] === "true") {
          Notification.success("سفارش شما با موفقیت ثبت شد");

          history.replace("/profile/orders");
        } else {
          Notification.danger("سفارش شما ثبت نشد دوباره اقدام نمایید");

          history.replace("/profile/orders");
        }
      }
    }
  }, [getOrders, history]);

  return (
    <>
      <Div className="mx-1 mt-5 pt-3">
        {isLoadingGetData ? (
          <Loading />
        ) : orders.length ? (
          <>
            {orders.map((order, index) => (
              <Item key={index} data={order} getOrders={getOrders} />
            ))}
          </>
        ) : (
          <Empty message="درحال حاضر شما سفارش فعالی ندارید" />
        )}
      </Div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth?.user,
  };
};

export default connect(mapStateToProps, { setUser })(Ongoing);
